<ng-template #details let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">{{ displaydetails.title }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<div class="mb-3" *ngIf="displaydetails">
			<h4></h4>
			<ng-container *ngIf="displaydetails.type == 'html'">
				<div [innerHTML]="displaydetails.display">
				</div>
			</ng-container>
			<ng-container *ngIf="displaydetails.type == 'pdf'">
				<ngx-extended-pdf-viewer [base64Src]="displaydetails.display" useBrowserLocale="true" [handTool]="false" [textLayer]="true" [showOpenFileButton]="false" [showPropertiesButton]="false" [showHandToolButton]="true" [filenameForDownload]="displaydetails.title"></ngx-extended-pdf-viewer>
			</ng-container>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<div class="main-content">
	<div class="container-fluid">
		<div class="row tp-wrapper m-0 p-0">
			<div class="col-md-12 ">
				<div class="card ">
					<div class="card-header card-header-{{color}}-6">
						<h4 class="card-title" (click)="back()">
							<i class="material-icons">arrow_left</i>
							{{ title }}
						</h4>
					</div>
					<div class="card-body">

						<div class="row">
							<div class="col-md-3">
								<mat-form-field appearance="outline">
									<mat-label>Vendors</mat-label>
									<mat-select [formControl]="selectedvendors" multiple appSelectAll>
										<mat-option *ngFor="let vendor of vendors" [value]="vendor.supplierid">
											{{ vendor.supplierid }} - {{ vendor.suppname }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-3">
								<mat-form-field appearance="outline">
									<mat-label>Transaction Types</mat-label>
									<mat-select [formControl]="selectedtypes" multiple>
										<mat-option *ngFor="let type of type_filters" [value]="type.value">
											{{ type.name }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline" class="full-width">
									<mat-label>Date Range</mat-label>
									<mat-date-range-input [rangePicker]="dateRangePicker">
										<input matStartDate [formControl]="datefrom" placeholder="From">
										<input matEndDate [formControl]="dateto" placeholder="To">
									</mat-date-range-input>
									<mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
									<mat-date-range-picker #dateRangePicker></mat-date-range-picker>
								</mat-form-field>
							</div>
							<div class="col-md-2">
								<button class="mt-3" mat-raised-button color="accent" (click)="loadData()" [disabled]="running">Load</button>&nbsp;&nbsp;

								<span *ngIf="running || exporting"><svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
										<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
									</svg>
								</span>

								<button class="btn btn-success btn-sm" (click)="$event.preventDefault();exportXls()" *ngIf="payments.summary && payments.transactions && !running && !exporting && payments.transactions.length">
									<i class="fa fa-file-excel-o"></i> XLS
								</button>
								&nbsp;&nbsp;
								<button class="btn btn-danger btn-sm" (click)="$event.preventDefault();exportPdf()" *ngIf="payments.summary && payments.transactions && !running && !exporting && payments.transactions.length">
									<i class="fa fa-file-pdf-o"></i> PDF
								</button>
							</div>
						</div>

						<div class="row m-0 p-0 mt-3 ">
							<div class="col-md-12" id="payrep" *ngIf="!running">
								<ng-container *ngIf="payments.transactions">
									<div class="table">
										<div class="bg-white mt-2 rounded">
											<div id="receipts">
												<h3 class="mt-2 mb-4 noprint">{{ title }}</h3>
												<p class="location-sub-header">
													{{ getVendorNamesFormatted() }}
												</p>

												<div class="table table-responsive table-fluid">
													<h3>Summary</h3>
													<div class="bg-white mt-2 rounded ">
														<div id="receipts">
															<table class="table table-fixed compact table-sm w-50 collapsed noprint">
																<thead>
																	<tr>
																		<th>Type</th>
																		<th class="text-right">Amount</th>
																	</tr>
																</thead>
																<tbody>
																	<tr *ngFor="let p of payments.summary">
																		<td>{{ p.type }}</td>
																		<td class="text-right"> {{ p.amount | currency }}</td>
																	</tr>
																	<tr>
																		<th>CC Total</th>
																		<th class="text-right">{{ cctotal | currency }} </th>
																	</tr>
																	<tr>
																		<th>Total</th>
																		<th class="text-right"> {{ total_pay | currency }}</th>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>

													<div class="row m-0 p-0">
														<div class="col-6">
															<mat-form-field appearance="outline">
																<mat-label>Search</mat-label>
																<input type="text" class="text-left" matInput [formControl]="searcher" />
															</mat-form-field>
														</div>
														<div class="col-6">
															<mat-paginator [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault"></mat-paginator>
														</div>
													</div>

													<div class="table-responsive">
														<table id="rcptTable" name="rcptTable" class="table compact table-sm table-fixed table-fluid table-sm-responsive collapsed w-100" *ngIf="payments.transactions && payments.transactions.length">
															<thead>
																<tr>
																	<th class="text-left">Date</th>
																	<th class="text-center">Document#</th>
																	<th class="text-center">Type</th>
																	<th class="text-left">Vendor#</th>
																	<th class="text-left">Vendor Name</th>
																	<th class="text-center">Reference</th>
																	<th class="text-right">Amount</th>
																	<th class="text-right">Tax</th>
																	<th class="text-right">Fee</th>
																	<th class="text-right">Discount</th>
																	<th class="text-right"><b>Total</b></th>
																	<th class="text-right"><b>Applied</b></th>
																	<th class="text-right"><b>Balance</b></th>
																	<th class="text-center">Settled</th>
																</tr>
															</thead>

															<tbody>
																<ng-container *ngFor="let pay of dataObs | async">
																	<tr>
																		<td class="text-left"> {{ pay.trandate }}</td>
																		<td class="text-center">
																			<a href="#" (click)="$event.preventDefault();openDocument(pay,'html')"> {{ pay.transno }}</a>
																		</td>
																		<td class="text-center"> {{ pay.typename }} </td>
																		<td class="text-left text-nowrap">
																			<a [routerLink]="'/vendors/view/' + pay.supplierno">
																				<b>{{ pay.supplierno }}</b>
																			</a>
																		</td>
																		<td class="text-left name-column">{{ pay.suppname }}</td>
																		<td class="text-center"> {{ pay.suppreference }}</td>
																		<td class="text-right"> {{ pay.ovamount | currency }}</td>
																		<td class="text-right"> {{ pay.ovgst | currency }}</td>
																		<td class="text-right"> {{ pay.ovfee | currency }}</td>
																		<td class="text-right"> {{ pay.discountavail | currency }}</td>
																		<td class="text-right">{{ pay.total | currency }}</td>
																		<td class="text-right" [ngClass]="{'text-success': pay.settled == 'Yes', 'text-danger': pay.settled == 'No'}">{{ pay.alloc | currency }}</td>
																		<td class="text-right">{{ pay.balance | currency }}</td>
																		<td class="text-center"> {{ pay.settled }}</td>
																	</tr>
																</ng-container>

																<tr>
																	<td class="text-center"><b>TOTALS</b></td>
																	<td class="text-center"></td>
																	<td class="text-center"></td>
																	<td class="text-right text-nowrap"></td>
																	<td class="text-left text-nowrap"></td>
																	<td class="text-center"></td>
																	<td class="text-right text-nowrapnumber"> {{ total_sub | currency }}</td>
																	<td class="text-right text-nowrapnumber"> {{ total_tax | currency }}</td>
																	<td class="text-right text-nowrapnumber"> {{ total_fee | currency }}</td>
																	<td class="text-right text-nowrapnumber"> {{ total_discount | currency }}</td>
																	<td class="text-right text-nowrapnumber">{{ total_trans | currency }}</td>
																	<td class="text-right"></td>
																	<td class="text-right"></td>
																	<td class="text-center"></td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</div>
									</div>
								</ng-container>
								<ng-container *ngIf="payments.transactions && !payments.transactions.length">
									<h3 class="text-center">No Transactions Found</h3>
								</ng-container>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>


